
export enum DynamicPriceLTLBillStatusCd {
	BILLED = 'Billed',
	CANCELLED = 'Cancelled',
	IN_FBES_SUSPENSE_QUEUE = 'InFBESSuspenseQueue',
	PAID = 'Paid',
	RATED = 'Rated',
	UNBILLED = 'Unbilled'}

